import React, { useState, useCallback, useEffect, useRef } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import AllTable from "../components/commontable/table";
import { getBatchData } from "../features/batch/batchSlice";
import WarningIcon from "../components/IconComp/warningIcon";
import WarningIconYellow from "../components/IconComp/warningIconYellow";
import { useLocation } from "react-router-dom";
import { EditBatchToolbar } from "../components/inventory/batch/batch-edit-toolbar";
import LoadingSpinner from "../components/common/Loading";
import NoDataMessage from "../components/common/NoDataMessage";
import SearchIcon from "../components/IconComp/searchIcon";
import { PurchasesHeader } from "../utils/constants";
import usePermissions from "../hooks/usePermissions";
import { getAllStaffPermissions } from "../features/staff/staffSlice";
import { styles } from "../screens/purchasesStyles";
import PdfDownloadIcon from "../components/IconComp/pdfDownloadIcon";
import AppModal from "../components/common/AppModal";
import StockInvoiceHistory from "../components/stockHistory";
import { ColorPallet } from "../utils/colorPallet";
interface IProps {
  getMedicine: any;
}
const Purchases = ({ getMedicine }: IProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isFromExpireMedBatch =
    location.state && location.state.fromExpireMedBatch;
  const [showExpired, setShowExpired] = useState(false);
  const [selectedDate, setSelectedDate] = useState<string>(); // Set the current date by default
  const [showNearExpiry, setShowNearExpiry] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  //pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(""); // Debounce
  const [searchQuery, setSearchQuery] = useState("");
  const rowData = useAppSelector((state) => state?.batch);
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const isPermissions = usePermissions();
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );
  const [selectedId, setSelectedId] = useState<number | string>("");
  const pharmacy_Id: any = localStorage?.getItem("pharmacyId");

  const [openPdf, setOpenPdf] = useState(false);
  const handleOpenPdf = () => {
    setOpenPdf(true);
  };
  const handleClosePdf = () => {
    setOpenPdf(false);
  };

  const GetAllStaffPermissions = useCallback(() => {
    dispatch(getAllStaffPermissions(pharmacy_Id)).then((res: any) => {
      if (res?.payload?.success === true) {
      }
    });
  }, [dispatch]);

  useEffect(() => {
    if (pharmacy_Id) {
      GetAllStaffPermissions();
    }
  }, [pharmacy_Id, GetAllStaffPermissions]);

  // Debounce effect for search query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust debounce delay as needed
    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  // const getBatch = useCallback(() => {
  //   setIsLoading(true);
  //   dispatch(getBatchData({ pharmacy_id: pharmacyId }));
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 500);
  // }, [dispatch, pharmacyId]);

  const getBatch = useCallback(async () => {
    const dto: any = {
      page: page + 1, // API pages are 1-indexed
      limit: rowsPerPage,
      search: debouncedSearchQuery,
      date: selectedDate, // Assuming there's a selected date
      id: selectedId ? selectedId : undefined, // Assuming there's an ID filter
      // added_by: addedByChecked ? addedByChecked : undefined,
      // updated_by: updatedByChecked ? updatedByChecked : undefined,
      expire_med: showExpired ? showExpired : undefined,
      near_expire: showNearExpiry ? showNearExpiry : undefined,
    };

    try {
      setIsLoading(true);
      const res = await dispatch(
        getBatchData({ pharmacy_id: pharmacyId, dto })
      );
      if (res.payload) {
        setTotalCount(res?.payload?.pagination?.totalItems || 0); // Ensure number type
      }
    } catch (error) {
      console.error("Error fetching manufacturer data:", error);
    } finally {
      setIsLoading(false);
      // setTimeout(() => {
      //   setIsLoading(false);
      // }, 500);

      // Only focus if there's an active search query
      if (debouncedSearchQuery) {
        setTimeout(() => {
          searchInputRef.current?.focus();
        }, 0);
      }
    }
  }, [
    dispatch,
    pharmacyId,
    page,
    rowsPerPage,
    debouncedSearchQuery,
    selectedDate,
    selectedId,
    showExpired,
    showNearExpiry,
    // addedByChecked,
    // updatedByChecked
  ]);

  // Preserve cursor position while typing
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { selectionStart, selectionEnd } = e.target; // Save cursor position
    setSearchQuery(e.target.value);
    setPage(0);
    // Restore cursor position after state update
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.setSelectionRange(selectionStart, selectionEnd);
      }
    }, 0);
  };

  useEffect(() => {
    if (Account_Type === 0 || (isPermissions?.view && Account_Type === 1)) {
      getBatch();
      if (isFromExpireMedBatch) {
        setShowExpired(true);
      }
    } else {
      setIsLoading(false);
    }
  }, [getBatch, isPermissions.view, Account_Type, isFromExpireMedBatch]);

  const filteredData = rowData?.batchDetails?.filter((item: any) => {
    if (!showExpired && !showNearExpiry && !isFromExpireMedBatch) {
      return true; // Show all data when no checkbox is checked and not from expireMedBatch action
    }

    const currentDate = new Date();
    const expiryDate = new Date(item?.expiry_date);
    const daysUntilExpiry = Math?.floor(
      (expiryDate?.getTime() - currentDate?.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (isFromExpireMedBatch) {
      return daysUntilExpiry < 0; // Only show expired medicines when coming from isFromExpireMedBatch
    }

    if (showExpired && daysUntilExpiry < 0) {
      return true;
    }

    if (showNearExpiry && daysUntilExpiry >= 0 && daysUntilExpiry <= 180) {
      return true;
    }
    return false;
  });

  // Filter data based on search query
  const filteredSearchData = filteredData
    ?.filter((item: any) => {
      return (
        item?.batch_no?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        item?.pharmacy_medicine?.name
          ?.toLowerCase()
          ?.includes(searchQuery?.toLowerCase()) ||
        item?.non_medical_product?.name
          ?.toLowerCase()
          ?.includes(searchQuery?.toLowerCase()) ||
        item?.supplier?.supplier_company_name
          ?.toLowerCase()
          ?.includes(searchQuery?.toLowerCase()) ||
        item?.stock_inv_no?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      );
    })
    ?.sort((a: any, b: any) =>
      a?.pharmacy_medicine?.name
        ?.toLowerCase()
        ?.localeCompare(b?.pharmacy_medicine?.name?.toLowerCase())
    ); // Sort alphabetically by medicine name

  const filterData = () => {
    return filteredSearchData?.filter((item: any) => {
      if (selectedId) {
        if (selectedId === "All") {
          return true;
        } else if (selectedId === "true") {
          return (
            item?.add_by_admin === true ||
            item?.updatedBatch?.some(
              (batchItem: any) => batchItem?.staff === null
            )
          );
        } else {
          return (
            item?.staff?.id === selectedId ||
            item?.updatedBatch?.some(
              (batchItem: any) => batchItem?.staff?.id === selectedId
            )
          );
        }
      }
      if (selectedDate) {
        return item?.batch_purchase_date?.includes(selectedDate); // Only filter by the date
      }
      return true;
    });
  };



  const tableRow = rowData?.batchDetails?.map((item: any) => {
    const currentDate = new Date();
    const expiryDate = new Date(item?.expiry_date);
    const daysUntilExpiry = Math?.floor(
      (expiryDate?.getTime() - currentDate?.getTime()) / (1000 * 60 * 60 * 24)
    );
    let expireIcon = null;
    if (daysUntilExpiry < 0) {
      // Medicine is expired
      expireIcon = <WarningIcon />;
    } else if (daysUntilExpiry <= 180) {
      // Medicine is near expiry
      expireIcon = <WarningIconYellow />;
    }

    return {
      "Batch No.": item?.batch_no,
      "Medicine Name": (
        <>
          {item?.pharmacy_medicine?.name}{" "}
          <span
            style={{
              fontSize: "10px",
              position: "relative",
            }}
          >
            {item?.pharmacy_medicine?.dose}
          </span>
        </>
      ),

      "Extra Discount/Bonus":
        item?.batch_discount !== null ? item?.batch_discount?.toFixed(2) : "-",
      "Purchase Date":
        item?.batch_purchase_date !== null &&
        item?.batch_purchase_date !== undefined
          ? new Date(item?.batch_purchase_date)?.toLocaleDateString("en-GB", {
              timeZone: "UTC",
            })
          : "-",
      Quantity: item?.quantity ? item?.quantity.toFixed(2) : "-",
      "Rate": item?.cost_price ? item?.cost_price : "-",
      "Total Amt": (item?.cost_price * item?.quantity) ? (item?.cost_price * item?.quantity).toFixed(2) : "-",
      "Stock Cost Price":
        item?.stock_purchase_cost?.toFixed(2) !== null
          ? item?.stock_purchase_cost?.toFixed(2)
          : "-",
      "Sales Tax":
        item?.tax_amount?.toFixed(2) !== null
          ? item?.tax_amount?.toFixed(2)
          : "-",

      "Invoice ID": item?.stock_inv_no,

      "Stock Discount":
        item?.stock_discount?.toFixed(2) !== null
          ? item?.stock_discount?.toFixed(2) !== null
          : "-",
      "Expire Date": (
        <Box sx={styles.expireBox}>
          {expireIcon}
          {item?.expiry_date
            ? new Date(item?.expiry_date)?.toLocaleDateString()
            : ""}
        </Box>
      ),
      "Supplier Name": item?.supplier?.supplier_company_name
        ? item?.supplier?.supplier_company_name
        : "-",

      Actions: (
        <>
          <Box sx={styles.editBatch}>
            {(isPermissions?.edit && Account_Type === 1) ||
            Account_Type === 0 ? (
              <EditBatchToolbar batch={item} isEdit={true} />
            ) : null}
          </Box>
        </>
      ),
    };
  });

  const hasAccess =
    Account_Type === 0 || (isPermissions?.view && Account_Type === 1);

  const tableRowData = hasAccess ? tableRow : [];

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset to first page when changing page size
  };

  return (
    <>
      {isLoading ? (
        <Box sx={styles.mainContainer}>
          <LoadingSpinner />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              margin: 1,
              backgroundColor: ColorPallet?.bgcolor,
              // marginTop: "10px",
              // padding: "10px",
              borderRadius: "5px",
              minHeight: {
                xs: "auto",
                sm: "80vh",
              },
              my: "1.2%",
            }}
          >
            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
                px: 1,
                mx: 0,
              }}
            >
              {/* Search Field */}
              <Box sx={{ ...styles.textFieldSearchContainer, m: 0, p: 0 }}>
                <TextField
                  inputRef={searchInputRef}
                  variant="outlined"
                  size="small"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ ...styles.textFieldLength, m: 0, p: 0 }}
                />
              </Box>

              {/* Right Section */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  m: 0,
                  p: 0,
                }}
              >
                {/* Print Button */}
                <Box
                  sx={{
                    display: "flex",
                    cursor:
                      tableRowData?.length === 0 ? "not-allowed" : "pointer",
                    alignItems: "center",
                    opacity: tableRowData?.length === 0 ? 0.5 : 1,
                    m: 0,
                    p: 0,
                  }}
                  onClick={
                    tableRowData?.length === 0 ? undefined : handleOpenPdf
                  }
                >
                  <Box sx={{ mr: 1 ,fontSize: {xs:"12px",sm:"17px"} }}>Print Stock History</Box>
                  <PdfDownloadIcon />
                </Box>

                {/* Date Field */}
                <TextField
                  type="date"
                  label="Purchase Date"
                  value={selectedDate}
                  size="small"
                  onChange={(e) => setSelectedDate(e?.target?.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: "227px", m: 0, p: 0 }}
                />
              </Box>
            </Box>

            <Box sx={styles.secondBox}>
              <Box sx={styles.thirdBox}></Box>
            </Box>
            <Box sx={styles.lastTable}>
              <AllTable
                headerData={PurchasesHeader}
                rowData={tableRowData}
                page={page}
                rowsPerPage={rowsPerPage}
                totalCount={totalCount}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                hasAccess={hasAccess}
              />
            </Box>
            <AppModal
              title="Stock History"
              open={openPdf}
              handleClose={handleClosePdf}
              fullScreen={false}
              maxWidth="md"
            >
              <StockInvoiceHistory
                tableRowData={rowData?.batchDetails}
                handleClosePdf={handleClosePdf}
              />
            </AppModal>
          </Box>
        </>
      )}
    </>
  );
};
export default Purchases;
